import { useMemo } from "react";
import PropTypes from "prop-types";
import { toast } from "sonner";
import { z } from "zod";

import { BaseForm, FormCombobox } from "components/BaseForm";
import { useUserFormOptions, useUserMutations } from "hooks/useUsersTable";

const schema = z.object({
  role_id: z.number({
    required_error: "A role is required",
    invalid_type_error: "A role is required",
  }),
});

const EditRoleForm = ({ userIds, onSuccess, onCancel }) => {
  const { roles } = useUserFormOptions();
  const { updateRoles } = useUserMutations();

  const roleOptions = useMemo(
    () =>
      (roles.data ?? []).map(({ id, name }) => ({
        key: id,
        value: id,
        text: name,
      })),
    [roles.data]
  );

  const handleSubmit = async ({ role_id }) => {
    await updateRoles.mutateAsync({ userIds, role: role_id });
  };

  const handleSuccess = () => {
    toast.success("Roles updated");
    onSuccess();
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{ role_id: null }}
      onSubmit={handleSubmit}
      onSuccess={handleSuccess}
      onCancel={onCancel}
    >
      <FormCombobox
        name="role_id"
        label="Role"
        required
        options={roleOptions}
      />
    </BaseForm>
  );
};

EditRoleForm.propTypes = {
  userIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default EditRoleForm;
